import * as UnitCstics from "~/Configurators/Linear/v2/configuration/UnitCstics";
import * as RailCstics from "~/Configurators/Rail/v2/configuration/classic/RailsCstics";
import * as CarriageCstic from "~/Configurators/Carriage/v2/configuration/CarriageCstics";
import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";

export const UnitDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  [UnitCstics.CarriageAmountRail1]: "1.0",
  [UnitCstics.RailAmount]: "1.0",

  [UnitCstics.SizeCode]: "",
  [UnitCstics.MaterialName]: "",

  [UnitCstics.Coating]: "/",
  [UnitCstics.Accuracy]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUSE", "KUVE", "KUVE..-W"],
      },
      value: "G3",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "RUE",
      },
      value: "G2",
    },
  ],
  [UnitCstics.Preload]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUSE", "KUVE", "KUVE..-W"],
      },
      value: "V1",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "RUE",
      },
      value: "V3",
    },
  ],

  [UnitCstics.HeightSorting]: "N",

  [RailCstics.GuidewayLength]: "",

  [UnitCstics.RailLocatingFaceSegment1]: "O",
  [UnitCstics.CarriageLocatingFaceSegment1]: "O",

  [UnitCstics.RailLocatingFaceSegment2]: "O",
  [UnitCstics.CarriageLocatingFaceSegment2]: "O",

  [UnitCstics.GreasingPerGreaseGroup]: "/",
  [UnitCstics.GreasingLType]: "/",
  [UnitCstics.GuidewayDesign]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "KUVE..-W",
      },
      value: "W",
    },
    {
      condition: {
        type: "not",
        value: {
          type: "equals",
          cstic: UnitCstics.MaterialName,
          value: "KUVE..-W",
        },
      },
      value: "/",
    },
  ],
  [UnitCstics.MountingHoleType]: "/",

  [RailCstics.ClosingPlugs]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "RUE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: ["25", "35", "45", "55", "65"],
          },
        ],
      },
      value: "KA..TN/B",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "RUE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "100",
          },
        ],
      },
      value: "KA..M",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUSE", "KUVE"],
      },
      value: "KA..TN/B",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUVE..-W",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: ["15", "20"],
          },
        ],
      },
      value: "KA..TN/A",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUVE..-W",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: ["25", "30", "35"],
          },
        ],
      },
      value: "KA..TN/B",
    },
  ],

  [UnitCstics.CounterboreChamfered]: "",
  [UnitCstics.PartSizing]: "N",
  [UnitCstics.PartAmount]: "",

  [UnitCstics.SMDS]: "N",
  [UnitCstics.SectionHeight]: "",

  [CarriageCstic.CarriageDesign]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "RUE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "100",
          },
        ],
      },
      value: "L",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUVE..-W",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: ["15", "20", "25", "30"],
          },
        ],
      },
      value: "W",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUVE..-W",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "35",
          },
        ],
      },
      value: "WL",
    },
    "/",
  ],
  [CarriageCstic.KitsLeft]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUVE..-W", "KUSE"],
      },
      value: "100",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "RUE",
      },
      value: "120",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "KUVE",
      },
      value: "220",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUSE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "45",
          },
        ],
      },
      value: "230",
    },
  ],
  [CarriageCstic.KitsCenter]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUSE", "KUVE", "KUVE..-W"],
      },
      value: "900",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "RUE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "25",
          },
        ],
      },
      value: "910",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "RUE",
          },
          {
            type: "not",
            value: {
              type: "equals",
              cstic: UnitCstics.SizeCode,
              value: "25",
            },
          },
        ],
      },
      value: "930",
    },
  ],
  [CarriageCstic.KitsRight]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: ["KUVE..-W", "KUSE"],
      },
      value: "100",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "RUE",
      },
      value: "120",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "KUVE",
      },
      value: "220",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUSE",
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "45",
          },
        ],
      },
      value: "230",
    },
  ],
  [CarriageCstic.LubricationConnectorStatus]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: ["RUE", "KUVE", "KUVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "U",
          },
        ],
      },
      value: "BL",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: ["RUE", "KUVE", "KUVE..-W"],
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "O",
          },
        ],
      },
      value: "BR",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "U",
          },
        ],
      },
      value: "L",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUSE",
          },
          {
            type: "equals",
            cstic: CarriageCstic.LocatingFace,
            value: "O",
          },
        ],
      },
      value: "R",
    },
  ],
  [CarriageCstic.LubricationConnector]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: ["KUVE", "KUVE..-W"],
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "20",
          },
        ],
      },
      value: "S04",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: ["KUVE", "KUVE..-W"],
          },
          {
            type: "equals",
            cstic: UnitCstics.SizeCode,
            value: "15",
          },
        ],
      },
      value: "S16",
    },
    {
      condition: {
        type: "or",
        value: [
          {
            type: "equals",
            cstic: UnitCstics.MaterialName,
            value: "KUSE",
          },
          {
            type: "and",
            value: [
              {
                type: "equals",
                cstic: UnitCstics.MaterialName,
                value: ["KUVE", "KUVE..-W"],
              },
              {
                type: "not",
                value: {
                  type: "equals",
                  cstic: UnitCstics.SizeCode,
                  value: ["15", "20"],
                },
              },
            ],
          },
        ],
      },
      value: "S05",
    },
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "RUE",
      },
      value: "S25",
    },
  ],
  [CarriageCstic.LubricationConnectorOrientation]: "M",
  [CarriageCstic.AngularOrientation]: [
    {
      condition: {
        type: "equals",
        cstic: UnitCstics.MaterialName,
        value: "KUSE",
      },
      value: "270°",
    },
    {
      condition: {
        type: "not",
        value: {
          type: "equals",
          cstic: UnitCstics.MaterialName,
          value: "KUSE",
        },
      },
      value: "/",
    },
  ],
};
